type FetchLike = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

export type AuthChallenge = {
  captchaId: string;
  targetY: number;
  bgImage: string;
  pieceImage: string;
};

export function createAuthChallengeClient(baseUrl: string, fetchImpl: FetchLike = fetch) {
  const challengeBaseUrl = baseUrl.replace(/\/+$/, "");
  return {
    async generate(): Promise<AuthChallenge> {
      const response = await fetchImpl(`${challengeBaseUrl}/challenge/generate`, {
        credentials: "omit",
        redirect: "error",
      });
      const body: unknown = await response.json();
      if (
        !response.ok
        || !body
        || typeof body !== "object"
        || !("success" in body) || body.success !== true
        || !("captchaId" in body) || typeof body.captchaId !== "string"
        || !("targetY" in body) || typeof body.targetY !== "number"
        || !("bgImage" in body) || typeof body.bgImage !== "string"
        || !("pieceImage" in body) || typeof body.pieceImage !== "string"
      ) {
        throw new Error("验证码加载失败");
      }
      return body as AuthChallenge;
    },

    async verify(captchaId: string, x: number) {
      const response = await fetchImpl(`${challengeBaseUrl}/challenge/verify`, {
        method: "POST",
        credentials: "omit",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ captchaId, x }),
        redirect: "error",
      });
      const body: unknown = await response.json();
      return response.ok
        && !!body
        && typeof body === "object"
        && "success" in body
        && body.success === true;
    },
  };
}
